import React, {Component} from "react";
import {Button, Checkbox} from "antd";
import {message} from "../../../utils/sysManagementUtils";
import CmSearchInput from "../../../../../components/CmSearchInput/CmSearchInput";
import "./UserListToolBar.scss";
import CmModal from "../../../../../components/CmModal/CmModal";
import BaseComponent from "../../../../../base/BaseComponent";

export default class UserListToolBar extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            batchDeleteVisible: false
        };
    }

    render() {
        const {
            searchValue,
            onSearch,
            onSearchValueChange,
            ifContainSonDept,
            onContainSonDeptChange,
            selectedRows,
        } = this.props;

        const {
            batchDeleteVisible
        } = this.state;
        return (
            <div id="UserListToolBar">
                <div className="UserListToolBar-left">
                    {/*用户添加弹窗*/}
                    <Button onClick={this.props.showEditUserModal} type="primary"
                            style={{marginRight: 15}}>添加用户</Button>
                    <Button onClick={this.batchDeleteHandle}>删除用户</Button>
                </div>
                <div className="UserListToolBar-right">
                    <CmSearchInput
                        searchValue={searchValue}
                        onSearch={onSearch}
                        onSearchValueChange={onSearchValueChange}
                        placeholder="请输入关键字"
                    />
                    <Checkbox style={{marginLeft: 15}} checked={ifContainSonDept}
                              onChange={e => onContainSonDeptChange(e.target.checked)}>包含子部门</Checkbox>
                </div>

                {/*删除用户弹窗*/}
                <CmModal
                    handleOk={this.batchDelete}
                    handleCancel={this.handleCancel}
                    visible={batchDeleteVisible}
                    title="批量删除"
                >
                    <div>以下用户将被删除：</div>
                    <div style={{margin:'5px 0'}}>
                        {selectedRows.map(item => item.name).join("，")}
                    </div>
                </CmModal>

            </div>
        );
    }

    /**
     * 批量删除
     */
    batchDelete = () => {
        const ids = [];
        const {updateTable, selectedRows} = this.props;
        selectedRows.forEach(function (item) {
            ids.push(item.id);
        });
        if (ids.length > 0) {
            this.delUserRequest(ids.join(","), res => {
                if (res) {
                    message.success("用户删除成功");
                    updateTable();
                    this.handleCancel();
                }
            });
        }
    };

    handleCancel = () => {
        this.setState({
            addUserVisible: false,
            batchDeleteVisible: false
        });
    };

    batchDeleteHandle = () => {
        const {selectedRowKeys} = this.props;
        console.log(selectedRowKeys)
        if(!selectedRowKeys.length){
            message.error('请选择用户！');
            return false
        }
        if (selectedRowKeys.length) {
            this.setState({
                batchDeleteVisible: true
            });
        }
    };

    delUserRequest = (ids, callBack) => {
        this.request({
            url: "/cm-sites-sys/user/delUser",
            body: {ids},
            callBack
        });
    };

}

